import { render, staticRenderFns } from "./AreYourDetailsUpToDate.vue?vue&type=template&id=c61fa89a&"
import script from "./AreYourDetailsUpToDate.vue?vue&type=script&lang=js&"
export * from "./AreYourDetailsUpToDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports